module.exports = __webpack_public_path__ + "img/maintenance-banner.cbf613a0.png";